import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import PurchaseOrderActions, { purchaseOrderActionTypes } from '../actions/purchaseOrderActions';
import PurchaseOrderServices from '../services/purchaseOrderServices';

/**
 * @param action
 */
function* _getDownloadPOData(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(PurchaseOrderActions.getDownloadPODataLoading(true));
    const poData = yield PurchaseOrderServices.downloadPOData(payload, callback);
    if (poData?.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email once ready.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: poData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseOrderActions.getDownloadPODataLoading(false));
  } catch (error) {
    yield put(PurchaseOrderActions.getDownloadPODataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.ERROR, error));
  }
}

function* downloadPOData() {
  yield takeLatest(purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.REQUEST, _getDownloadPOData);
}
/**
 * @param action
 */
function* _getPurchaseOrders(action) {
  try {
    yield put(PurchaseOrderActions.getPurchaseOrdersLoading(true));
    const {
      orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch, mrpId, tags, departmentIds, excludeMrpLinked, destinationTenantId, isListScreen, excludeJobWorksPo, excludeSubcontractorPo, linkedPoIds
    } = action;
    const purchaseOrder = yield PurchaseOrderServices.getPurchaseOrders(orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch, mrpId, tags, departmentIds, excludeMrpLinked, destinationTenantId, isListScreen, excludeJobWorksPo, excludeSubcontractorPo, linkedPoIds);
    yield put(PurchaseOrderActions.getPurchaseOrdersSuccess(purchaseOrder));
    if (action.callback) {
      action.callback(purchaseOrder);
    }
    yield put(PurchaseOrderActions.getPurchaseOrdersLoading(false));
  } catch (error) {
    yield put(PurchaseOrderActions.getPurchaseOrdersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.GET_PURCHASE_ORDERS.ERROR, error));
  }
}

/**
 *
 */
function* getPurchaseOrders() {
  yield takeLatest(purchaseOrderActionTypes.GET_PURCHASE_ORDERS.REQUEST, _getPurchaseOrders);
}
/**
 * @param action
 */
function* _createPurchaseOrder(action) {
  try {
    yield put(PurchaseOrderActions.createPurchaseOrderLoading(true));
    const purchaseOrder = yield PurchaseOrderServices.createPurchaseOrder(action.payload);
    if (purchaseOrder.success) {
      yield put(TrackerActions.trackAction(purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.SUCCESS, action?.payload));
      notification.open({
        type: 'success',
        message: 'Purchase order successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.createPurchaseOrderLoading(false));
      if (action.callback) {
        action.callback(purchaseOrder);
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseOrder?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.createPurchaseOrderLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.ERROR, error));
    yield put(PurchaseOrderActions.createPurchaseOrderLoading(false));
  }
}

/**
 *
 */
function* createPurchaseOrder() {
  yield takeLatest(purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.REQUEST, _createPurchaseOrder);
}

/**
 * @param action
 */
function* _approvePO(action) {
  try {
    yield put(PurchaseOrderActions.approvePOLoading(true, action.payload.step_status));
    const purchaseOrder = yield PurchaseOrderServices.approvePO(action.payload);
    if (purchaseOrder.success) {
      notification.open({
        type: 'success',
        message: 'Approved Purchase Order successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.approvePOLoading(false, action.payload.step_status));
      action.callback(purchaseOrder?.workflow?.steps);
    } else {
      notification.open({
        type: 'error',
        message: purchaseOrder?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.approvePOLoading(false, action.payload.step_status));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.APPROVE_PO.ERROR, error));
    yield put(PurchaseOrderActions.approvePOLoading(false, action.payload.step_status));
  }
}

/**
 *
 */
function* approvePO() {
  yield takeLatest(purchaseOrderActionTypes.APPROVE_PO.REQUEST, _approvePO);
}

/**
 *
 * @param {*} action
 */
function* _updatePurchaseOrder(action) {
  try {
    yield put(PurchaseOrderActions.updatePurchaseOrderLoading(true));
    const purchaseOrder = yield PurchaseOrderServices.updatePurchaseOrder(action.payload);
    if (purchaseOrder.success) {
      yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.SUCCESS, purchaseOrder.data));
      notification.open({
        type: 'success',
        message: 'Purchase order updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.updatePurchaseOrderLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseOrder.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.updatePurchaseOrderLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.ERROR, error));
    yield put(PurchaseOrderActions.updatePurchaseOrderLoading(false));
  }
}

/**
 *
 */
function* updatePurchaseOrder() {
  yield takeLatest(purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.REQUEST, _updatePurchaseOrder);
}

/**
 *
 * @param {*} action
 */
function* _updatePurchaseOrderExpiryDate(action) {
  try {
    yield put(PurchaseOrderActions.updatePurchaseOrderExpiryDateLoading(true));
    const purchaseOrder = yield PurchaseOrderServices.updatePurchaseOrderExpiryDate(action.payload);
    if (purchaseOrder.success) {
      yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.SUCCESS, purchaseOrder.data));
      notification.open({
        type: 'success',
        message: 'Purchase order expiry date updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.updatePurchaseOrderExpiryDateLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseOrder.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PurchaseOrderActions.updatePurchaseOrderExpiryDateLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.ERROR, error));
    yield put(PurchaseOrderActions.updatePurchaseOrderExpiryDateLoading(false));
  }
}

/**
 *
 */
function* updatePurchaseOrderExpiryDate() {
  yield takeLatest(purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.REQUEST, _updatePurchaseOrderExpiryDate);
}

/**
 * @param action
 */
function* _getPOAnalytics(action) {
  try {
    const {
      startDate, endDate, tenantId, sellerId, orgId,
    } = action;
    yield put(PurchaseOrderActions.getPOAnalyticsLoading(true));
    const purchaseData = yield PurchaseOrderServices.getPOAnalytics(startDate, endDate, tenantId, sellerId, orgId);
    yield put(PurchaseOrderActions.getPOAnalyticsSuccess(purchaseData));
    yield put(PurchaseOrderActions.getPOAnalyticsLoading(false));
  } catch (error) {
    yield put(PurchaseOrderActions.getPOAnalyticsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.GET_PO_ANALYTICS.ERROR, error));
  }
}

/**
 *
 */
function* getPOAnalytics() {
  yield takeLatest(purchaseOrderActionTypes.GET_PO_ANALYTICS.REQUEST, _getPOAnalytics);
}

/**
 * @param action
 */
function* _getPurchaseOrderById(action) {
  try {
    yield put(PurchaseOrderActions.getPurchaseOrderByIdLoading(true));
    const selectedPo = yield PurchaseOrderServices.getPurchaseOrderById(action.poId, action.tenantId);
    yield put(PurchaseOrderActions.getPurchaseOrderByIdSuccess(selectedPo?.purchase_order[0]));
    if (action.callback) {
      action.callback(selectedPo?.purchase_order?.[0]?.seller_info?.seller_id);
    }
    yield put(PurchaseOrderActions.getPurchaseOrderByIdLoading(false));
  } catch (error) {
    yield put(PurchaseOrderActions.getPurchaseOrderByIdLoading(false));
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getPurchaseOrderById() {
  yield takeLatest(purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.REQUEST, _getPurchaseOrderById);
}

/**
 * @param action
 */
function* _getPoSequence(action) {
  try {
    yield put(PurchaseOrderActions.getPoSequenceLoading(true));
    const poSequence = yield PurchaseOrderServices.getPoSequence(action.tenantId);
    if (poSequence) {
      if (action.callback) {
        action.callback(poSequence.data);
      }
    }
    yield put(PurchaseOrderActions.getPoSequenceSuccess(poSequence?.data));
    yield put(PurchaseOrderActions.getPoSequenceLoading(false));
  } catch (error) {
    yield put(PurchaseOrderActions.getPoSequenceLoading(false));
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.GET_PO_SEQUENCE.ERROR, error));
  }
}

/**
 *
 */
function* getPoSequence() {
  yield takeLatest(purchaseOrderActionTypes.GET_PO_SEQUENCE.REQUEST, _getPoSequence);
}

/**
 * @param action
 */
function* _updatePoStatus(action) {
  try {
    yield put(PurchaseOrderActions.updatePoStatusLoading(true));
    const poStatusUpdate = yield PurchaseOrderServices.updatePoStatus(action.payload);
    if (['SENT_FOR_APPROVAL', 'ISSUED', 'CANCELLED'].includes(poStatusUpdate.status)) {
      notification.open({
        type: 'success',
        message: 'Purchase order status updated successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: poStatusUpdate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(PurchaseOrderActions.updatePoStatusLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.messages,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PO_STATUS.ERROR, error));
    yield put(PurchaseOrderActions.updatePoStatusLoading(false));
  }
}

/**
 *
 * @return {Generator<*, void, *>}
 */
function* updatePoStatus() {
  yield takeLatest(purchaseOrderActionTypes.UPDATE_PO_STATUS.REQUEST, _updatePoStatus);
}

/**
 * @param action
 */
function* _updatePoWorkflowStep(action) {
  try {
    yield put(PurchaseOrderActions.updatePoWorkflowStepLoading(true));
    const poStatusUpdate = yield PurchaseOrderServices.updatePoWorkflowStep(action.payload);

    if (poStatusUpdate.success) {
      if (action.callback) {
        action.callback();
      }
      if (action.payload[0]?.step_status === 'APPROVED') {
        notification.open({
          type: 'success',
          message: 'Purchase has been approved.',
          duration: 4,
          placement: 'top',
        });
      } else {
        notification.open({
          type: 'success',
          message: poStatusUpdate?.message,
          duration: 4,
          placement: 'top',
        });
      }
    } else {
      notification.open({
        type: 'error',
        message: poStatusUpdate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseOrderActions.updatePoWorkflowStepLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PO_WORKFLOW_STEP.ERROR, error));
    yield put(PurchaseOrderActions.updatePoWorkflowStepLoading(false));
  }
}

/**
 *
 */
function* updatePoWorkflowStep() {
  yield takeLatest(purchaseOrderActionTypes.UPDATE_PO_WORKFLOW_STEP.REQUEST, _updatePoWorkflowStep);
}

/**
 * @param action
 */
function* _deletePurchaseOrder(action) {
  try {
    yield put(PurchaseOrderActions.deletePurchaseOrderLoading(true));
    const deletedPo = yield PurchaseOrderServices.deletePurchaseOrder(action.payload);
    if (deletedPo.success) {
      notification.open({
        type: 'success',
        message: 'Purchase has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedPo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseOrderActions.deletePurchaseOrderLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.DELETE_PURCHASE_ORDER.ERROR, error));
    yield put(PurchaseOrderActions.deletePurchaseOrderLoading(false));
  }
}

/**
 *
 */
function* deletePurchaseOrder() {
  yield takeLatest(purchaseOrderActionTypes.DELETE_PURCHASE_ORDER.REQUEST, _deletePurchaseOrder);
}

/**
 * @param action
 */
function* _updatePoSequence(action) {
  try {
    yield put(PurchaseOrderActions.updatePoSequenceLoading(true));
    const updateSqn = yield PurchaseOrderServices.updatePoSequence(action.payload);
    if (updateSqn.success) {
      notification.open({
        type: 'success',
        message: 'Document sequence has been updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updateSqn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseOrderActions.updatePoSequenceLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.UPDATE_PO_SEQUENCE.ERROR, error));
    yield put(PurchaseOrderActions.updatePoSequenceLoading(false));
  }
}

/**
 *
 */
function* updatePoSequence() {
  yield takeLatest(purchaseOrderActionTypes.UPDATE_PO_SEQUENCE.REQUEST, _updatePoSequence);
}

/**
 * @param action
 */
function* _sendPoMailToVendor(action) {
  try {
    yield put(PurchaseOrderActions.sendPOMailToVendorLoading(true));
    const mailResponse = yield PurchaseOrderServices.sendPoMailToVendor(action.payload);
    if (mailResponse?.success) {
      if (action.callback) {
        action.callback();
      }
      notification.open({
        type: 'success',
        message: 'Purchase order sent to vendor successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: mailResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(PurchaseOrderActions.sendPOMailToVendorLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.SEND_PO_EMAIL_TO_VENDOR.ERROR, error));
    yield put(PurchaseOrderActions.sendPOMailToVendorLoading(false));
  }
}

/**
 *
 */
function* sendPoMailToVendor() {
  yield takeLatest(purchaseOrderActionTypes.SEND_PO_EMAIL_TO_VENDOR.REQUEST, _sendPoMailToVendor);
}

function* _closePo(action) {
  try {
    yield put(PurchaseOrderActions.closePoLoading(true));
    const response = yield PurchaseOrderServices.closePo(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'Purchase order has been marked as closed',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(PurchaseOrderActions.closePoLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.CLOSE_PO.ERROR, error));
    yield put(PurchaseOrderActions.closePoLoading(false));
  }
}

function* closePo() {
  yield takeLatest(purchaseOrderActionTypes.CLOSE_PO.REQUEST, _closePo);
}

function* _sendPoWhatsapp(action) {
  try {
    yield put(PurchaseOrderActions.sendPoWhatsappLoading(true));
    const response = yield PurchaseOrderServices.sendPoWhatsapp(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'Purchase order has been sent to the vendor over whatsapp.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(PurchaseOrderActions.sendPoWhatsappLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseOrderActionTypes.SEND_PO_WHATSAPP.ERROR, error));
    yield put(PurchaseOrderActions.sendPoWhatsappLoading(false));
  }
}

function* sendPoWhatsapp() {
  yield takeLatest(purchaseOrderActionTypes.SEND_PO_WHATSAPP.REQUEST, _sendPoWhatsapp);
}

/**
 *
 */
export default function* purchaseOrderSaga() {
  yield all([
    downloadPOData(),
    getPurchaseOrders(), createPurchaseOrder(), updatePurchaseOrder(), getPurchaseOrderById(),
    getPOAnalytics(), approvePO(), getPoSequence(), updatePoStatus(), updatePurchaseOrderExpiryDate(),
    updatePoWorkflowStep(), deletePurchaseOrder(), updatePoSequence(), sendPoMailToVendor(), closePo(), sendPoWhatsapp(),
  ]);
}
